<template>
  <Modal
    id="credit-card-refund-history"
    title="Histórico de Restituições"
    :active.sync="active"
    @close="close"
  >
    <div class="mt-4">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 20%">Data e Hora</th>
            <th style="width: 20%">Usuário</th>
            <th style="width: 10%">Valor</th>
            <th style="width: 10%; text-align: center;">Status</th>
            <th style="width: 40%">Mensagem de Retorno</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(refund, index) in refunds" :key="index">
            <td>{{ formatDate(refund.createdAt, true) }}</td>
            <td>{{ refund.userId }} - {{ refund.userName }}</td>
            <td>{{ refund.refundedAmount | currency }}</td>
            <td class="flex justify-center">
              <vs-chip  :color="getStatusConfigs(refund.status).color">
                {{ getStatusConfigs(refund.status).label }}</vs-chip
              >
            </td>
            <td>{{ refund.returnMessage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Modal>
</template>
<script>
import checkoutService from '../../services/checkout';
import functions from '../../utils/functions';

import Modal from '../../components/Modal.vue';
import notify from '../../utils/notify';

export default {
  name: 'ModalCrditCardRefundHistory',
  components: {
    Modal,
  },
  props: {
    activeProp: {
      type: Boolean,
      default: false,
    },
    purchaseIdProp: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formatDate: functions.formataDataHoraPadraoBR,
      refunds: [],
      active: false,
      purchase: null,
    };
  },
  watch: {
    activeProp() {
      if (this.activeProp) {
        this.open();
      }
    },
  },
  methods: {
    getStatusConfigs(status) {
      const configsByStatus = {
        success: {
          label: 'Sucesso',
          color: 'success',
        },
        fail: {
          label: 'Falha',
          color: 'danger',
        },
      };

      return (
        configsByStatus[status] || {
          label: status,
          color: 'warning',
        }
      );
    },
    async open() {
      try {
        const data = await checkoutService.getCreditCardRefunds(
          this.purchaseIdProp,
        );

        this.refunds = data.refunds || [];

        this.active = this.activeProp;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    close() {
      this.active = false;
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="scss">
.table-bordered {
  font-size: 1rem;
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
<style>
#credit-card-refund-history.con-vs-popup .vs-popup {
  width: fit-content !important;
  min-width: 60% !important;
}
</style>
